import {alertMessage} from "../messages";
/**
 * Вывод уведомлений при работе формы
 * @param type <p>Тип уведомлений</p>
 * @param message <p>Выводимое сообщение</p>
 * @param options <p>Параметры для уведомлений</p>
 */
export function notification(type, message, options) {
    "use strict";
    switch (type) {
        case "NotificationFx":
            notificationNotificationFX.call(this, message, options);
            break;
        case "custom":
            formCustomNotificate.call(this, message, options);
            break;
        default:
            formCustomNotificate.call(this, message, options);
    }
}

// Нотификация при помощи NotificationFx
function notificationNotificationFX(message, options) {
    "use strict";
    var notification = new NotificationFx({
        wrapper: document.body,
        message: message,
        layout: 'attached',
        effect: 'bouncyflip',
        type: options.theme,
        ttl: options.ttl,
        onClose: function () {
            return false;
        },
        onOpen: function () {
            return false;
        }
    });
    notification.show();
}


// Собственная нотификация
function formCustomNotificate(message, options) {
    alertMessage('', message);
}